import { motion } from 'framer-motion';
import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const ResourceSearchBarWrapper = styled.div`
  width: 100%;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 24px;

  padding: 10px;

  border-radius: 8px;
  background: ${({ theme }) =>
    (theme.currentStep === 1 || theme.isFocused) && !theme.isLoading
      ? '#ffffff'
      : 'rgba(255, 255, 255, 0.50)'};

  ${({ theme }) =>
    theme.currentStep === 1 &&
    !theme.isLoading &&
    `
    min-height: 103px;
    align-items: flex-start;
  `}

  ${({ theme }) =>
    theme.currentStep !== 1 &&
    `
    align-self: center;
  `}
`;

export const ResourceSearchBarContainer = styled.div`
  flex: 1;

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;

  ${BREAKPOINTS.tablet} {
    gap: 12px;
  }
`;

export const ResourceSearchBarResetContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
`;

export const ResourceSearchBarInformationContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const ResourceSearchBarGroupsWrapper = styled(motion.div)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
`;

export const ResourceSearchBarGroupContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;

  padding: 2px 8px 2px 3px;
`;

interface ResourceSearchBarGroupLabelProps {
  isUnrecognized?: boolean;
}

export const ResourceSearchBarGroupLabel = styled.span<ResourceSearchBarGroupLabelProps>`
  font-weight: 400;
  font-size: 12px;
  line-height: normal;

  color: ${({ isUnrecognized }) =>
    isUnrecognized ? 'rgba(23, 28, 51, 0.3)' : 'rgba(23, 28, 51, 0.5)'};
`;

export const ResourceSearchBarPrompt = styled.span`
  font-weight: 400;
  font-size: 18px;
  line-height: normal;

  color: var(--color-text);
`;
export const ResourceSearchBarInput = styled.textarea`
  width: 100%;

  font-weight: 400;
  font-size: 18px;
  line-height: normal;

  &::placeholder {
    font-weight: 400;
    font-size: 18px;
    line-height: normal;

    ${BREAKPOINTS.tablet} {
      font-size: 16px;
    }

    color: rgba(23, 28, 51, 0.5);
  }

  ${BREAKPOINTS.tablet} {
    font-size: 16px;
  }

  color: var(--color-primary);

  border: none;
  resize: none;

  &:focus {
    outline: none;
  }

  background: none;
`;
